import { getApiErrorReason } from "../../lib/api/apiError";
import { formatMoney } from "./financeMoney";

const STATUS_LABELS = [
  "bad request",
  "unauthorized",
  "forbidden",
  "not found",
  "conflict",
  "internal server error",
  "service unavailable",
  "bad gateway",
  "gateway timeout",
];

const I18N_KEY = /^[a-z0-9]+(\.[a-z0-9_]+)+$/;

export const usable = (text) => {
  const value = String(text ?? "").trim();

  if (!value) return false;
  if (value.length > 300) return false;
  if (/<[a-z][\s\S]*>/i.test(value)) return false;
  if (I18N_KEY.test(value)) return false;
  if (STATUS_LABELS.includes(value.toLowerCase())) return false;

  return true;
};

export const serverMessage = (error, fallback) => {
  const reason = getApiErrorReason(error);

  return usable(reason) ? reason : fallback;
};

export const FINANCE_COPY = {
  emailRequired: {
    title: "Email Required",
    message: "Add an email address to your profile before topping up your wallet.",
  },
  topUpFailed: {
    title: "Top-Up Failed",
    message: "Could not start the top-up. Please try again.",
  },
  topUpWalletGone: {
    title: "Top-Up Failed",
    message: "That wallet is no longer available. Please try again.",
  },
  topUpPending: {
    title: "Top-Up Pending",
    message: "We have not seen the payment land yet. Your balance will update as soon as it clears.",
  },
  walletReadFailed: "Could not read your wallet. Please try again.",
  feeFailed: "Could not work out the withdrawal fee",
  withdrawalFailed: "Could not request this withdrawal",
  recipientDeleteFailed: "Could not remove this account",
  cancelWithdrawalFailed: "Could not cancel this withdrawal request",
  chooseAccountAndAmount: "Choose an account and an amount to withdraw.",
  bankSaved: { title: "Account Added", message: "Your bank account is saved for withdrawals." },
  momoSaved: {
    title: "Account Added",
    message: "Your mobile money account is saved for withdrawals.",
  },
};

export const toppedUpMessage = (money) => `${formatMoney(money)} has been added to your wallet.`;

export const withdrawalRequestedMessage = (money) =>
  `Your withdrawal of ${formatMoney(money)} has been requested. We will let you know once it is paid.`;

export const FINANCE_EMPTY_STATES = {
  noRecipients: {
    title: "No Withdrawal Account Yet",
    body: "Add a bank or mobile money account to receive your withdrawals.",
  },
  noTransactions: {
    title: "No Transactions Yet!",
    body: "Top-ups, order payments and refunds will appear here.",
  },
  transactionsError: {
    title: "Couldn't Load Transactions",
    body: "Refresh and we'll try again.",
  },
  noTopUps: {
    title: "No Top-Ups Yet",
    body: "Money you add to your wallet will be listed here.",
  },
  noPayments: {
    title: "No Order Payments Yet",
    body: "Payments you make for orders will be listed here.",
  },
  noWithdrawalAccount: {
    title: "No Withdrawal Account",
    body: "Add a bank or mobile money account in Finance to receive your withdrawals.",
  },
  noWithdrawals: {
    title: "No Withdrawal Requests",
    body: "Withdrawals you request will be listed here.",
  },
  walletError: {
    title: "Couldn't Load Your Wallet",
    body: "Something went wrong reading your balance. Please try again.",
  },
};

export const AMOUNT_ERRORS = {
  zero: "Enter an amount greater than zero.",
  min: (money) => `Enter at least ${formatMoney(money)}.`,
  max: (money) => `You can enter up to ${formatMoney(money)}.`,
};
